const KyLokal = {
  draw: {
    toolbar: {
      actions: {
        title: 'Жокко чыгаруу',
        text: 'Отмена'
      },
      finish: {
        title: 'Чийүүнү аяктоо',
        text: 'Аяктоо'
      },
      undo: {
        title: 'Акыркы чийилген чекитти жок кылуу',
        text: 'Акыркыны жок кылуу'
      },
      buttons: {
        polyline: 'Көптөгөн сызыктарды тартуу',
        polygon: 'Көп бурчтук тартуу',
        rectangle: 'Тик бурчтук тартуу',
        circle: 'Тегерек тартуу',
        marker: 'Маркер тартуу',
        circlemarker: 'Тегерек маркер тартуу'
      }
    },
    handlers: {
      circle: {
        tooltip: {
          start: 'Тегерек тартуу үчүн басып сүйрөңүз'
        },
        radius: 'Радиус'
      },
      circlemarker: {
        tooltip: {
          start: 'Маркер-чөйрөнү жайгаштыруу үчүн картаны басыныз.'
        }
      },
      marker: {
        tooltip: {
          start: 'Маркерди жайгаштыруу үчүн картаны басыңыз'
        }
      },
      polygon: {
        tooltip: {
          start: 'Сүрөттү тартуу үчүн картаны басыңыз',
          cont: 'Форманы тартууну улантуу үчүн басыңыз',
          end: 'Сүрөттү бүтүрүү үчүн басыңыз'
        }
      },
      polyline: {
        error: '<strong>Ката:</strong> фигуранын четтери кесилишпейт!',
        tooltip: {
          start: 'Сызык тартуу үчүн, картаны басыңыз',
          cont: 'Сызык тартууну улантуу үчүн басыңыз',
          end: 'Сызык тартууну аяктоо үчүн басыңыз'
        }
      },
      rectangle: {
        tooltip: {
          start: 'Тик бурчтукту тартуу үчүн басып жылдырыңыз'
        }
      },
      simpleshape: {
        tooltip: {
          end: 'Сүрөттү бүтүрүү үчүн, чычканды кое бер'
        }
      }
    }
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: 'Өзгөртүүлөрдү сактоо',
          text: 'Сактоо'
        },
        cancel: {
          title: 'Мурунку өзгөртүүлөрдү этибарга албай, түзөтүүнү жокко чыгарыңыз',
          text: 'Кайтуу'
        },
        clearAll: {
          title: 'Бардык катмарларды алып салыңыз',
          text: 'Баарын жок кыл'
        }
      },
      buttons: {
        edit: 'Катмарларды өзгөртүү',
        editDisabled: 'Түзөтүү үчүн катмарлар жок',
        remove: 'Катмарларды жок кылуу',
        removeDisabled: 'Жок кылуу үчүн катмарлар жок'
      }
    },
    handlers: {
      edit: {
        tooltip: {
          text: 'Объектти түзөтүү үчүн окторду же маркерди сүйрөңүз.',
          subtext: 'Өзгөртүүлөрдү жокко чыгаруу үчүн, "жокко чыгаруу" баскычын басыңыз.'
        }
      },
      remove: {
        tooltip: {
          text: 'Объектти алып салуу үчүн, аны басыңыз.'
        }
      }
    }
  }
};

export default KyLokal